import SalesSummary from './components/SalesSummary';
import SalesChart from './components/TotalSellPieChart';
import { Box, Grid, GridItem } from '@chakra-ui/react';
import TotalOrderChart from './components/TotalOrderBarChart';
import RecentOrder from './components/RecentOrdersTable';
import TopSellingProgressBar from './components/TopSellingProgressBar';
import PendingOrder from './components/PendingOrderTable';

const Dashboard = () => {
  return (
    <Box fontFamily={'primary'} p={{ base: 4, md: 6 }}>
      <SalesSummary />
      {/* <Box mt={4} mb={4}>
        <PendingOrder />
      </Box> */}
      <Grid templateColumns={{ base: '1fr', xl: '3fr 2fr' }} gap={4} mt={4}>
        {/* <GridItem> */}
        <TotalOrderChart />
        {/* </GridItem> */}
        {/* <GridItem> */}
        <PendingOrder />

        {/* </GridItem> */}
      </Grid>
      <Grid templateColumns={{ base: '1fr', lg: '1fr 1fr' }} gap={4} mt={4} mb={4}>
        <GridItem>
          <SalesChart />
        </GridItem>
        <GridItem>
          <TopSellingProgressBar />
        </GridItem>
      </Grid>
      <RecentOrder />
    </Box>
  );
};

export default Dashboard;
